module.exports = __webpack_public_path__ + "static/media/portfolio-v2-min.d8b17665.png";